<template>
  <a-modal
    :visible="visible"
    :centered="true"
    :footer="false"
    :mask-closable="false"
    @cancel="handleCancel"
  >
    <div class="content">
      <h3><i class="iconfont iconicon-test68" />{{ $t('message["1617"]') }}！</h3>
      <ul>
        <li
          v-for="item in data"
          :key="item.fieldkey"
        >
          <span v-if="item.matchtype === 1">{{ tips2[0] }}{{ item.fieldname }} <i class="fs-warning">{{ item.fieldvalue }}</i> {{ tips2[1] }}</span>
          <span v-else-if="item.matchtype === 2">{{ tips1[0] }}{{ item.fieldname }}{{ tips1[1] }} <i class="fs-warning">{{ item.fieldvalue }}</i> {{ tips1[2] }}</span>
          <a
            v-if="item.iscancheckrepeat"
            href="javascript:;"
            class="look-repeat-btn"
            @click="handleClickRepeat(item)"
          >{{ $t('message["85"]') }}</a>
        </li>
      </ul>
      <div class="footer">
        <a-button
          v-if="data[0] && data[0].isrepeatsave"
          type="primary"
          @click="handleOk"
        >
          {{ $t('message["467"]') }}
        </a-button>
        <a-button
          type="default"
          @click="handleCancel"
        >
          {{ $t('message["287"]') }}
        </a-button>
      </div>
    </div>
  </a-modal>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: () => []
    },
    saveType: {
      type: String,
      default: ''
    },
    againSaveForm: {
      type: Function,
      default: () => { }
    }
  },
  computed: {
    pid () {
      return this.$route.params.pid
    },
    tips1 () {
      return this.$t('message["1453"]').split('|')
    },
    tips2 () {
      return this.$t('message["1454"]').split('|')
    }
  },
  watch: {
    visible (val) {
      this.isVisible = val
    }
  },
  methods: {
    hide () {
      this.$emit('update:visible', false)
    },
    async handleOk () {
      let checkrepeatconfirm = 1
      await this.againSaveForm({ saveType: this.saveType, checkrepeatconfirm })
      this.hide()
    },
    handleCancel () {
      this.hide()
    },
    handleClickRepeat (item) {
      let { fieldkey, fieldvalue } = item
      if (Array.isArray(fieldvalue)) {
        fieldvalue = fieldvalue.join(',')
      }

      let href = `${location.origin}/project/${this.pid}/inquery/repeat?repeatfieldkey=${fieldkey}&repeatfieldvalue=${fieldvalue}`
      var tempwindow = window.open()
      tempwindow.location = href
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  padding-left: 40px;
}
h3 {
  font-weight: bold;
  height: 24px;
  line-height: 24px;
  margin-left: -40px;
  .iconfont {
    float: left;
    margin-right: 16px;
    font-size: 24px;
    color: $warning-color;
  }
}
ul {
  margin: 8px 0 24px;
  color: $gray2;
  i {
    font-style: normal;
  }
  li {
    padding: 3px 0;
    line-height: 22px;
  }
  .look-repeat-btn {
    margin-left: 16px;
  }
}
</style>
